<template>
    <v-card class="fill-height">
        <v-toolbar card dark color="primary">
            <v-toolbar-title>Scan een product</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat icon @click="$emit('close')">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-card-text v-if="loading">
            <v-layout justify-center>
                <v-progress-circular indeterminate color="primary" />
            </v-layout>
        </v-card-text>

        <template v-else-if="scannerEnabled">
            <barcode-scanner :confirmsNeeded="confirmsNeeded"
                            @detected="onDetected" @confirmed="onConfirmed" @error="onError" />
            <div class="scan-target">
                <v-progress-linear fixed center :value="confirmPercentage" color="primary" />
            </div>
            <v-btn fab fixed bottom right icon dark color="accent" @click="$emit('close')">
                <v-icon>stop</v-icon>
            </v-btn>
        </template>

        <v-card-text v-else-if="scannerError" class="fill-height">
            <v-icon x-large>error</v-icon>
            <p>
                Helaas ging er iets mis. Dit komt waarschijnlijk omdat de app geen toegang heeft
                tot de camera op je apparaat. Check of je toestemming hebt gegeven en probeer het opnieuw.
            </p>
        </v-card-text>

        <v-card-text v-else-if="!infoFound" class="fill-height">
            <p>Gescande code:</p>
            <h2>{{ product.barcode }}</h2>
            <p>Helaas konden we geen productinformatie vinden bij deze streepjescode.</p>
            <v-icon x-large>warning</v-icon>
            <p>Let op: Deze app geeft alleen productinformatie weer van <strong>voedingsproducten</strong>.</p>
        </v-card-text>

        <v-card-text v-else-if="product" class="fill-height">
            <p>We hebben de volgende informatie gevonden over dit product:</p>
            <product-info :product="product" />
            <p>Bron productinformatie: <a href="https://www.thequestionmark.org/" target="_blank">Questionmark</a></p>
        </v-card-text>

        <v-card-actions v-if="!scannerEnabled && !loading">
            <v-spacer />
            <v-btn @click="onReScanClick">
                <v-icon class="mr-2">redo</v-icon>
                Opnieuw scannen
            </v-btn>
            <v-btn color="primary" @click="onAddClick" v-if="product && !loading">
                <v-icon class="mr-2">add</v-icon>
                Toevoegen
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import BarcodeScanner from './Scanner'
import ProductInfo from './ProductInfo'
import axios from 'axios'

export default {
    components: {
        BarcodeScanner,
        ProductInfo,
    },
    data () {
        return {
            scannerEnabled: true,
            scannerError: false,
            infoFound: false,
            loading: false,
            confirmsNeeded: 5,
            confirmPercentage: 0,
            product: null,
        }
    },

    methods: {
        onDetected (scan) {
            this.confirmPercentage = (100.0 / this.confirmsNeeded) * scan.confirms
            console.log('confirm/percentage', scan.confirms, this.confirmPercentage)
            this.$forceUpdate()
        },
        onConfirmed (result) {
            this.product = {
                barcode: result.code,
            }
            this.scannerEnabled = false
            this.fetchProductInfo()
        },
        onError () {
            this.scannerEnabled = false
            this.scannerError = true
        },
        onReScanClick () {
            this.confirmPercentage = 0
            this.scannerEnabled = true
            this.scannerError = false
            this.product = null
        },
        onAddClick () {
            this.$emit('add', this.product)
            this.$emit('close')
        },
        async fetchProductInfo () {
            if (!this.product.barcode.match(/^[0-9]+$/)) {
                return
            }

            this.loading = true
            this.infoFound = false

            try {
                const url = `https://api-c.thequestionmark.org/api/v1.2/products/${this.product.barcode}`
                const result = await axios.get(url, {
                    headers: {
                        'Accept': 'application/json',
                        'X-User-Agent': 'Inspiratietuin Cell[0]',
                    },
                    timeout: 5000,
                })

                if (!result.data) {
                    return
                }

                this.product = {
                    barcode: this.product.barcode,
                    ...result.data,
                }
                this.infoFound = true
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style>
.scan-target {
    position: absolute;
    width: 50%;
    left: 25%;
    top: 50%;
    bottom: 50%;
}

</style>
